/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_1moInputs */

const en_pricing_1mo = /** @type {(inputs: Pricing_1moInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 month`)
};

const id_pricing_1mo = /** @type {(inputs: Pricing_1moInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 Bulan`)
};

/**
* | output |
* | --- |
* | "1 month" |
*
* @param {Pricing_1moInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pricing_1mo = /** @type {((inputs?: Pricing_1moInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_1moInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pricing_1mo(inputs)
	return en_pricing_1mo(inputs)
});